// Inner imports
import { WIDGET_FOOTER_HOOKS } from "./constants";

export const useWidgetFooter = (props: Widget.ChartProps): JSX.Element | null =>
  WIDGET_FOOTER_HOOKS[props.widgetId](props);
